// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bj6D","type":"styles_type__3Etmy","choices":"styles_choices__oobVn"};